export class MercerSupportPositionClassHelper {
  public static readonly seniorManagementPositionClassStart = 59;
  public static readonly minPositionClass = 40;
  public static readonly maxPositionClass = 80;
  public static readonly isoCodeDE = 'DE';
}
